module.exports = __webpack_public_path__ + "static/media/line-share-block.6e18331f.svg";